const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]'])

export function isLocalhostHostname(hostname) {
  return LOCALHOST_HOSTNAMES.has(hostname)
}

export function shouldRegisterPwa({ isProd, hostname }) {
  return Boolean(isProd) && !isLocalhostHostname(hostname)
}

export async function cleanupLocalDevPwa(serviceWorker = globalThis.navigator?.serviceWorker, cacheStorage = globalThis.caches) {
  if (serviceWorker?.getRegistrations) {
    const registrations = await serviceWorker.getRegistrations()
    await Promise.all(registrations.map(registration => {
      if (typeof registration.unregister === 'function') {
        return registration.unregister()
      }
      return Promise.resolve(false)
    }))
  }

  if (cacheStorage?.keys && cacheStorage?.delete) {
    const cacheKeys = await cacheStorage.keys()
    await Promise.all(cacheKeys.map(cacheKey => cacheStorage.delete(cacheKey)))
  }
}